<template>
    <v-btn
            color="primary"
            rounded
            class="d-flex align-center"
            @click="toggle"
    >
        <v-icon color="white" size="20" class="mr-1 ml-n1">mdi-filter</v-icon>
        Filtrar por
        <v-icon class="ml-1 mr-n2" small :class="{ 'rotate90': value }">chevron_right</v-icon>
    </v-btn>
</template>

<script>
  export default {
    name: 'FilterToggleButton',
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      toggle () {
        this.$emit('input', !this.value)
      }
    }
  }
</script>

<style scoped>
.rotate90 {
  transform: rotate(90deg);
  transition: transform 0.3s ease;
}
</style>
